import {Route,Switch,BrowserRouter } from "react-router-dom";

import DoobiHeader from "components/Headers/DoobiHeader";
import SubscriptionPackagesTable from "components/Doobi/SubscriptionPackages";

const SubscriptionPackagesRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Subscription Packages" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/`} component={SubscriptionPackagesTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default SubscriptionPackagesRoute;
